module.exports = __webpack_public_path__ + "img/male6.23931ff1.jpeg";